export default __webpack_public_path__ + "static/media/cassette-tape.e6c1e4f1.png";